export type ApiAccount = { userId: string; organizationId: string; domain: string };
export function apiAccountKey(account: ApiAccount) { return JSON.stringify([account.userId,account.organizationId,account.domain]); }
export async function scopedApiRequest<T>(base: string, account: ApiAccount, path: string, options: RequestInit,
  current: () => boolean, refresh: () => Promise<void>): Promise<T> {
  if (!current()) throw new Error('The selected account changed. Reload this page.');
  const headers = new Headers(options.headers);
  if (!headers.has('Content-Type')) headers.set('Content-Type','application/json');
  if (!headers.has('X-Organization-Id') && account.organizationId) headers.set('X-Organization-Id',account.organizationId);
  if (!headers.has('X-Shop-Domain') && account.domain && (headers.get('X-Organization-Id')||'')===account.organizationId) headers.set('X-Shop-Domain',account.domain);
  const send = () => fetch(`${base}${path}`,{...options,headers,credentials:'include',cache:'no-store'});
  let response = await send();
  if (!current()) throw new Error('The selected account changed. Reload this page.');
  if (response.status===401) {
    await refresh();
    if (!current()) throw new Error('The selected account changed. Reload this page.');
    if (!['GET','HEAD'].includes((options.method||'GET').toUpperCase())) throw new Error('Your session expired. Review the current result before retrying this change.');
    response = await send();
  }
  const data = await response.json().catch(()=>null);
  if (!current()) throw new Error('The selected account changed. Reload this page.');
  if (!response.ok || data===null || data.success===false) throw new Error(data?.error || (response.status===401?'Session expired. Please sign in again.':`Request failed (HTTP ${response.status})`));
  return data as T;
}
